module.exports = __webpack_public_path__ + "media/video.a935acdb.mp4";